import ButtonDropdown from '@pelckmans/elementis/components/button-dropdown';
import MaterialSiteIcon from '@pelckmans/elementis/icons/material-site';
import { useTranslation } from 'react-i18next';
import ModalContext from '../../contexts/ModalContext';
import { useContext } from 'react';
import { Module } from '../../api/module';
import usePlatformName from '../../hooks/usePlatformName';
import AddBookwidgetMaterialModal from '../elementis/components/add-material-modal/add-bookwidget-material-modal';
import { TOKEN_ACCESSOR } from '../../utils/tokenAccessor';
import { useWithLicenseCheck } from '../../pages/material/toc/components/teacher/useWithLicenseCheck';
import { buildAddBookwidgetUrl } from '../elementis/util/buildBookWidgetsUrl';

const BASE = 'PAGES.TOC_LEVEL.SECTIONS.TEACHER.MATERIAL';
const MODAL_ID = 'add-bookwidget-modal';

interface Props {
  module: Module;
  nodeId: string;
  onSubmit: () => void;
  onClick?: () => void; // Needed for Floating UI to handle onClicks correctly.
  extraPayload?: Record<string, string>;
}

export default function AddBookwidgetDropdownItem({
  module,
  nodeId,
  onSubmit: onSubmitCallback,
  onClick: onClickCallback,
  extraPayload,
  ...rest // Allows props to flow through to the item. This is needed for accessibility
}: Props) {
  const { t } = useTranslation();
  const { showModal } = useContext(ModalContext);
  const platformName = usePlatformName();
  const { licenseCheck } = useWithLicenseCheck();

  const onClick = licenseCheck(() => {
    showModal(
      <AddBookwidgetMaterialModal
        id={MODAL_ID}
        tokenAccessor={TOKEN_ACCESSOR}
        nodeId={nodeId}
        studioGroup={process.env.REACT_APP_P_STUDIO_GROUP}
        onSubmit={onSubmitCallback}
        bookwidgetUrl={buildAddBookwidgetUrl({
          ltipsUrl: process.env.REACT_APP_LTI_AUTH_URL,
          module,
          platformName,
          studioLanguage: process.env.REACT_APP_P_STUDIO_GROUP,
        })}
        extraPayload={extraPayload}
      />,
    );

    return onClickCallback?.();
  });

  return (
    <ButtonDropdown.Item
      onClick={onClick}
      text={t(`${BASE}.ADD_USER_MATERIAL_DROPDOWN_BUTTON.ITEMS.ADD_NEW_BOOKWIDGET`)}
      textIcon={<MaterialSiteIcon />}
      {...rest}
    />
  );
}
